import { FC } from 'react';
import { useLocation } from 'react-router-dom';
// Hooks
import useNavigateTo from 'hooks/useNavigateTo';
import { useAppSelector } from 'hooks/useStore';
// Types
import QuizTypes from 'types/QuizTypes';
// Seletors
import { selectQuiz } from 'store/quiz/quizSelectors';
// Components
import PublicDevicePlayable from 'components/PublicDevicePlayable';
import AppBar from 'components/AppBar';
import { Button } from 'components/Buttons';
// i18next
import { useTranslation } from 'react-i18next';

const AlreadyPassedPage:FC = () => {
  const { t } = useTranslation();
  const navigateTo = useNavigateTo();
  const { search } = useLocation();

  const queryParams = new URLSearchParams(search);
  const email = queryParams.get('email');

  const quiz = useAppSelector(selectQuiz);

  const isPollQuiz = [QuizTypes.Poll, QuizTypes.RankingPoll].includes(quiz.type);

  return (
    <div
      className="flex-1"
      style={{ background: quiz.backgroundImage ? `url('${quiz.backgroundImage}') center / cover` : '' }}
    >
      <PublicDevicePlayable />
      <div className="p-4"><AppBar /></div>
      {isPollQuiz ? <div className="h-24" />  : null}
      <div className="grow p-4 overflow-y-auto text-primary">
        <h2 className="text-center text-xl">
          {isPollQuiz ? t('pages.alreadyPassed.titlePoll') : t('pages.alreadyPassed.title')}
        </h2>
        <h2 className="font-bold text-center mb-4 text-xl break-words">
          {email}
        </h2>
        <h2 className="text-center mb-6 text-xl">
          {isPollQuiz ? t('pages.alreadyPassed.subtitlePoll') : t('pages.alreadyPassed.subtitle')}
        </h2>
        <div className="text-center">
          <Button
            className="w-full text-2xl uppercase primary-button"
            onClick={() => navigateTo('post-quiz')}
          >
            {isPollQuiz ? t('buttons.showResults') : t('buttons.showScore')}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default AlreadyPassedPage;
